import { CLIENT_ID, CLIENT_PUBLIC } from "../config";
import { getGenreCounts } from "../shared/utils/songs.utils";
//const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
//const CLIENT_PUBLIC = process.env.REACT_APP_CLIENT_PUBLIC;

export const spotify_redirect_uri = "http://apps.maxpinheiro.com%2Frecapify";
export const spotify_redirect_uri_unencoded = "http://apps.maxpinheiro.com/recapify";
export const local_spotify_redirect_uri = "http://localhost:3000";
export const local_spotify_redirect_uri_unencoded = "http://localhost:3000";
const spotify_api_root = "https://api.spotify.com/v1";

export const jsonToUrlEncoded = (obj: any) => Object.keys(obj).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])).join('&');

export enum ResponseStatus { Success = 200, UnknownError = 500, NotFound = 404, Unauthorized = 401 };

export type AccessTokenDto = {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
}

export const refreshAndRetry = async () => {

}

export const refreshTokens = async () => {

}

export const getTokens = async (authCode: string, local=true): Promise<AccessTokenDto | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`https://accounts.spotify.com/api/token`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": `Basic ${window.btoa(`${CLIENT_ID}:${CLIENT_PUBLIC}`)}`
        },
        body: jsonToUrlEncoded({
            grant_type: "authorization_code",
            code: authCode,
            redirect_uri: local ? local_spotify_redirect_uri_unencoded : spotify_redirect_uri_unencoded
        })
    });
    if (response.status === 200) {
        const data = await response.json();
        if (data.hasOwnProperty('access_token') && data.hasOwnProperty('refresh_token') && data.hasOwnProperty('expires_in')) {
            const accessToken = data['access_token'];
            const refreshToken = data['refresh_token'];
            const expiresIn = data['expires_in'];
            return { accessToken, refreshToken, expiresIn };
        } else {
            return ResponseStatus.UnknownError;
        }
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}
export type Artist = {
    id: string;
    genres: string[];
    images: {url: string}[];
    name: string;
}

export type Track = {
    external_urls: {spotify: string};
    id: string;
    name: string;
    artists: Artist[];
    preview_url: string;
    uri: string;
    album: {images: {url: string}[]};
}

export type LikedSongsDto = {
    items: Track[];
    total: number;
}

export const getLikedSongs = async (accessToken: string, offset: number, limit: number): Promise<LikedSongsDto | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`${spotify_api_root}/me/tracks?offset=${offset}&limit=${limit}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    });
    if (response.status === 200) {
        const data = await response.json();
        if (data.hasOwnProperty('items') && data.hasOwnProperty('total')) {
            return { items: data.items.map((item: ({track: Track})) => item.track) as Track[], total: data.total };
            /*const items = data.items;
            return (items.map((item: ({track: Track})) => item.track)) as Track[];
            */
        } else {
            return ResponseStatus.UnknownError;
        }
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}

export const getLikedSongsTotalCount = async (accessToken: string): Promise<number | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const singleSong = await getLikedSongs(accessToken, 0, 1);
    if (singleSong === ResponseStatus.Unauthorized || singleSong === ResponseStatus.UnknownError) return singleSong;
    return singleSong.total;
}

export const getAllLikedSongs = async (accessToken: string): Promise<Track[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const totalNum = await getLikedSongsTotalCount(accessToken);
    if (totalNum === ResponseStatus.UnknownError) return ResponseStatus.UnknownError;
    let currOffset = 0;
    let currTotal = 0;
    let collectedSongs: Track[] = [];
    while (currTotal < totalNum) {
        const songs = await getLikedSongs(accessToken, currOffset * 50, 50);
        if (songs === ResponseStatus.UnknownError || songs === ResponseStatus.Unauthorized) {
            //return ResponseStatus.UnknownError;
            return songs;
        }
        collectedSongs.push(...songs.items);
        currTotal += 50;
        currOffset++;
    }
    return collectedSongs;
}

export const getSongsByIds = async (accessToken: string, spotifyIds: string[]): Promise<Track[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`${spotify_api_root}/tracks?ids=${spotifyIds.join(',')}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    });
    if (response.status === 200) {
        const data = await response.json();
        if (data.hasOwnProperty('tracks')) {
            return data.tracks as Track[];
            /*const items = data.items;
            return (items.map((item: ({track: Track})) => item.track)) as Track[];
            */
        } else {
            return ResponseStatus.UnknownError;
        }
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}

export const getSongById = async (accessToken: string, spotifyId: string): Promise<Track | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`${spotify_api_root}/tracks/${spotifyId}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    });
    if (response.status === 200) {
        const data = await response.json();
        return data as Track;
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}

export type AudioFeature = {
    id: string;
    acousticness: number;
    danceability: number;
    energy: number;
    instrumentalness: number;
    liveness: number;
    loudness: number;
    mode: number;
    speechiness: number;
    valence: number;
}

export const emptyFeature: AudioFeature = {
    id: '0',
    acousticness: 0,
    danceability: 0,
    energy: 0,
    instrumentalness: 0,
    liveness: 0,
    loudness: 0,
    mode: 0,
    speechiness: 0,
    valence: 0,
}

export const getTracksAudioFeatures = async (accessToken: string, songIds: string[]): Promise<AudioFeature[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`${spotify_api_root}/audio-features?ids=${songIds.join(',')}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    });
    if (response.status === 200) {
        const data = await response.json();
        if (data.hasOwnProperty('audio_features')) {
            return data.audio_features as AudioFeature[];
        } else {
            return ResponseStatus.UnknownError;
        }
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}

export const getManyTracksAudioFeatures = async (accessToken: string, songIds: string[]): Promise<AudioFeature[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const totalNum = songIds.length;
    let currTotal = 0;
    let collectedFeatures: AudioFeature[] = [];
    while (currTotal < totalNum) {
        const features = await getTracksAudioFeatures(accessToken, songIds.slice(currTotal, Math.min(currTotal+100, songIds.length)));
        if (features === ResponseStatus.UnknownError || features === ResponseStatus.Unauthorized) {
            //return ResponseStatus.UnknownError;
            return features;
        }
        collectedFeatures.push(...features);
        currTotal += 100;
    }
    return collectedFeatures;
}

export type RecentlyPlayedTrack = Track & { played_at: string };

export const getRecentlyPlayeddd = async (accessToken: string, after: number, limit: number): Promise<RecentlyPlayedTrack[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    let totalTracks: RecentlyPlayedTrack[] = [];
    let now = Date.now();
    let next: string | null = `${spotify_api_root}/me/player/recently-played?before=${now}&limit=50`;
    while (next !== null && totalTracks.length < limit) {
        const response: Response = await fetch(next, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`
            }
        });
        if (response.status === 200) {
            const data = await response.json();
            console.log(data);
            if (data.hasOwnProperty('items') && data.hasOwnProperty('cursors')) {
                const tracks = data.items.map((item: ({track: Track, played_at: string})) => ({...item.track as Track, played_at: item.played_at})) as RecentlyPlayedTrack[];
                totalTracks.push(...tracks);
                const cursors = data.cursors;
                if (cursors && cursors.hasOwnProperty('after') && cursors.hasOwnProperty('before')) {
                    // latest bound (most recent to now)
                    //const afterTime = cursors.after;
                    // earliest bound (most distant to now)
                    const beforeTime = cursors.before;
                    //next = data.next || null;
                    next = `${spotify_api_root}/me/player/recently-played?before=${beforeTime}&limit=50`;
                } else {
                    next = null;
                }
            } else if (data.hasOwnProperty('items')) {
                const tracks = data.items.map((item: ({track: Track, played_at: string})) => ({...item.track as Track, played_at: item.played_at})) as RecentlyPlayedTrack[];
                totalTracks.push(...tracks);
                console.log(totalTracks.length);
                next = data.next || null;
            } else {
                return ResponseStatus.UnknownError;
            }
        } else if (response.status === 401) {
            console.log(response);
            return ResponseStatus.Unauthorized;
        } else {
            return ResponseStatus.UnknownError;
        }
    }
    return totalTracks;
}

export const getRecentlyPlayedMany = async (accessToken: string, after: number, limit: number): Promise<RecentlyPlayedTrack[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    let totalTracks: RecentlyPlayedTrack[] = [];
    let next: string | null = `${spotify_api_root}/me/player/recently-played?after=${after}&limit=50`;
    while (next !== null && totalTracks.length < limit) {
        const response: Response = await fetch(next, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`
            }
        });
        if (response.status === 200) {
            const data = await response.json();
            console.log(data);
            if (data.hasOwnProperty('items') && data.hasOwnProperty('cursors')) {
                const tracks = data.items.map((item: ({track: Track, played_at: string})) => ({...item.track as Track, played_at: item.played_at})) as RecentlyPlayedTrack[];
                totalTracks.push(...tracks);
                const cursors = data.cursors;
                if (cursors && cursors.hasOwnProperty('after') && cursors.hasOwnProperty('before')) {
                    // latest bound (most recent to now)
                    //const afterTime = data.cursors.after;
                    // earliest bound (most distant to now)
                    const beforeTime = data.cursors.before;
                    //next = data.next || null;
                    next = `${spotify_api_root}/me/player/recently-played?before=${beforeTime}&limit=50`;
                } else {
                    next = null;
                }
            } else if (data.hasOwnProperty('items')) {
                const tracks = data.items.map((item: ({track: Track, played_at: string})) => ({...item.track as Track, played_at: item.played_at})) as RecentlyPlayedTrack[];
                totalTracks.push(...tracks);
                console.log(totalTracks.length);
                next = data.next || null;
            } else {
                return ResponseStatus.UnknownError;
            }
        } else if (response.status === 401) {
            console.log(response);
            return ResponseStatus.Unauthorized;
        } else {
            return ResponseStatus.UnknownError;
        }
    }
    return totalTracks;
}

export const getRecentlyPlayed = async (accessToken: string, after: number, limit: number): Promise<RecentlyPlayedTrack[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`${spotify_api_root}/me/player/recently-played?after=${after}&limit=${limit}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    });
    if (response.status === 200) {
        const data = await response.json();
        if (data.hasOwnProperty('items')) {
            return data.items.map((item: ({track: Track, played_at: string})) => ({...item.track as Track, played_at: item.played_at})) as RecentlyPlayedTrack[];
        } else {
            return ResponseStatus.UnknownError;
        }
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}

export const getArtistById = async (accessToken: string, artistId: string): Promise<Artist | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`${spotify_api_root}/artists/${artistId}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    });
    if (response.status === 200) {
        const data = await response.json();
        return data as Artist;
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}

export type TopItemsType = "artists" | "tracks" | "genres";
export type TopItemsTimespan = "short_term" | "medium_term" | "long_term";
export const timespanOptions: TopItemsTimespan[] = ["short_term", "medium_term", "long_term"];

export const getTopItems = async (accessToken: string, type: TopItemsType, timespan: TopItemsTimespan): Promise<Track[] | Artist[] | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    const response = await fetch(`${spotify_api_root}/me/top/${type}?time_range=${timespan}`, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
        }
    });
    if (response.status === 200) {
        const data = await response.json();
        if (data.hasOwnProperty('items')) {
            //return (data.items.map((item: ({track: Track})) => item.track)) as Track[];
            return type === "artists" ? data.items as Artist[] : data.items as Track[];
        } else {
            return ResponseStatus.UnknownError;
        }
    } else if (response.status === 401) {
        console.log(response);
        return ResponseStatus.Unauthorized;
    } else {
        return ResponseStatus.UnknownError;
    }
}

export type TopItemsData = {
    artists: Record<TopItemsTimespan, Artist[]>,
    tracks: Record<TopItemsTimespan, Track[]>,
    genres: Record<TopItemsTimespan, ({genre: string, count: number})[]>
}

export const getAllTopItems = async (accessToken: string): Promise<TopItemsData | ResponseStatus.Unauthorized | ResponseStatus.UnknownError> => {
    let allData: TopItemsData = {
        artists: { short_term: [], medium_term: [], long_term: [] },
        tracks: { short_term: [], medium_term: [], long_term: [] },
        genres: { short_term: [], medium_term: [], long_term: [] }
    }
    for (let timespan of timespanOptions) {
        const topArtists = await getTopItems(accessToken, "artists", timespan);
        if (topArtists === ResponseStatus.Unauthorized || topArtists === ResponseStatus.UnknownError) {
            return topArtists;
        }
        const topTracks = await getTopItems(accessToken, "tracks", timespan);
        if (topTracks === ResponseStatus.Unauthorized || topTracks === ResponseStatus.UnknownError) {
            return topTracks;
        }
        const genreCounts = getGenreCounts(topArtists as Artist[]);
        allData["artists"][timespan] = topArtists as Artist[];
        allData["tracks"][timespan] = topTracks as Track[];
        allData["genres"][timespan] = genreCounts;
    }
    return allData;
}
